import { render, staticRenderFns } from "./PFDeregManual.vue?vue&type=template&id=680eadc9"
import script from "./PFDeregManual.vue?vue&type=script&lang=js"
export * from "./PFDeregManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports